import { __decorate, __metadata } from "tslib";
import { IsUUID } from 'class-validator';
/**
 * Contract for listing accounts of which a user is a member
 */
export class ListAccountsByUserIdParams {
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], ListAccountsByUserIdParams.prototype, "userId", void 0);
